import $ from 'jquery'

// ビューのインラインスクリプトが window.$ を参照するためグローバルに公開する
window.$ = $
window.jQuery = $

// rails-ujs 撤去（Turbo 移行）に伴い、$.ajax への CSRF トークン自動付与を自前で行う。
// これが無いと $.ajax の POST/PUT/DELETE が InvalidAuthenticityToken で 500 になる
// （fav.js のお気に入り登録、common.js の通知既読など）。
$.ajaxPrefilter((options, _originalOptions, xhr) => {
  if (options.crossDomain) return

  const token = document.querySelector('meta[name="csrf-token"]')?.content
  if (token) xhr.setRequestHeader('X-CSRF-Token', token)
})
